import React, { useEffect, useRef } from 'react';
import { Webplayer } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useWithCourse } from 'hookApi';
import { getCourse, getPlayerStatus } from 'redux/reducers';
import { isGuest } from 'redux/query';
import { Spinner } from 'Common';
import { getCourseBySlug } from 'redux/actions';

export const CoursePlayerPage = () => {
  const dispatch = useDispatch();
  const { slug } = useParams();
  const { isFetching } = useWithCourse();
  const prevSlugRef = useRef();
  const prevStatusRef = useRef();

  const content = useSelector(getCourse);
  const playerStatus = useSelector(getPlayerStatus);
  const guest = useSelector(isGuest);

  useEffect(() => {
    if (slug !== prevSlugRef.current) {
      window.scrollTo(0, 0);
      dispatch(getCourseBySlug(slug));
    }
    prevSlugRef.current = slug;
  }, [slug]);

  useEffect(() => {
    if (playerStatus !== prevStatusRef.current && playerStatus === 'end') {
      dispatch(getCourseBySlug(slug));
    }
    prevStatusRef.current = playerStatus;
  }, [playerStatus]);

  if (isFetching || !content || !content.id) {
    return <Spinner />;
  }

  return <Webplayer content={content} contentType="course" playerStatus={playerStatus} isGuest={guest} />;
};

export default CoursePlayerPage;
